<template>
<div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
        <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>
    <card>
        <div class="bg-light p-3">
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <h4 class="p-3" style="background-color: #024052; color: #ffffff;"><b>MAKLUMAT PEGAWAI</b></h4>
                </b-card-header>

                <b-card-body>
                    <b-card-text>
                        <!-- <b-container fluid class="mt--6"> -->
                        <!-- <card header-classes="bg-transparent"> -->
                        <!-- <h3 class="mb-0">Maklumat Penjawat Awam</h3> -->
                        
                        <div class="pl-lg-4 info-table">
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold"> No Kad Pengenalan</b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="3" class="value">{{ ICNo }}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold"> Nama </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="8" class="value">{{ objMaklPer.CONm }}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold">Klasifikasi Perkhidmatan Pertama </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="3" class="value">{{ objMaklPer.klasifikasi }}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold">Skim Perkhidmatan </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="3" class="value">{{ objMaklPer.skim }}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold">Gred Jawatan Lantikan Pertama </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="3" class="value">{{ objMaklPer.gred }}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold">Gaji Lantikan Pertama </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="3" class="value">{{ objMaklPer.SalGrdPertama }}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold">Tarikh Lantikan Pertama </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="3" class="value">{{ objMaklPer.DtLantikanPertama }}</b-col>
                            </b-row>
                            <!--<b-row class="my-1">
                                    <b-col sm="3">Tarikh Dijangka Bersara </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.TarikhJangkaBersara}}</b-col>
                                </b-row> -->
                            <br />
                            <b-row>
                                <b-col>
                                    <!-- <b-button size="md" variant="primary" @click="ToPageMaklumatperibadi()">KEMASKINI MAKLUMAT</b-button> -->
                                </b-col>
                            </b-row>
                        </div>
                        
                        <!-- </card> -->
                        <!-- </b-container> -->
                    </b-card-text>
                </b-card-body>

            </b-card>
        </div>
        <br />
        <div class="bg-white p-3">
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <h4 class="p-3" style="background-color: #024052; color: #ffffff;"><b>SIMULASI GAJI PEGAWAI</b></h4>
                </b-card-header>
                <b-card-body>
                    <b-card-text>
                        <div class="pl-lg-4">
                            <!-- <b-card-header class="border-0">-->
                                <!-- <h3 class="mb-0">STATUS GAJI TAHUNAN</h3> -->
                            <!--</b-card-header> -->
                            <el-table class="table-responsive table" header-row-class-name="thead-light"  :header-cell-style="{
                      background: '#f6f9fc',
                      color: '#000',
                      fontWeight: 'bold',
                      fontSize: '12px'
                    }" :data="objGajiCO" 
                     style="width: 100%" :cell-style="{ fontWeight: 600, color: '#000',fontSize: '14px' }" :cell-class-name="rowClassName">
                                <el-table-column align="center" type="index" width="100px">
                                </el-table-column>
                                <el-table-column label="TARIKH KUATKUASA" prop="EftDate" min-width="200px" align="center">
                                </el-table-column>
                                <el-table-column label="KETERANGAN" prop="keterangan" min-width="200px" align="center">
                                </el-table-column>
                                <el-table-column label="GRED" prop="SalGrdID" min-width="150px" align="center">
                                </el-table-column>
                                <el-table-column label="TARIKH PERGERAKAN GAJI (TPG)" prop="TPG" min-width="250px" align="center">
                                </el-table-column>
                                <el-table-column prop="AmaunTelahTerima" min-width="250px" align="center" :cell-style="(row) => compareAmounts(row, 'AmaunTelahTerima')" :formatter="formatCurrency">
                                    <template #header>
                                        <span style="font-size: 11px;">AMAUN TELAH TERIMA (RM) </span><br />
                                        <span style="font-size: 10px;">(seperti yang dicatat dalam BPK pegawai)</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="SalAmtCalc" min-width="250px" align="center" :cell-style="(row) => compareAmounts(row, 'AmaunTelahTerima')" :formatter="formatCurrency">
                                    <template #header>
                                        <span style="font-size: 11px;">AMAUN PATUT TERIMA (RM) </span><br />
                                        <span style="font-size: 10px;">(semakan sistem)</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="TANGGA GAJI" prop="JadualGaji" min-width="200px" align="center">
                                </el-table-column>
                                <el-table-column label="CATATAN" prop="Catatan" min-width="200px" align="center">
                                </el-table-column>
                                <!-- Checkbox
                                <el-table-column
                                    type="selection"
                                    width="100px"
                                    align="center"
                                /> -->
                            
                                <el-table-column label="Tindakan" min-width="200px" align="center">
                                    <template slot="header">
                                        <div style="width: 100%; text-align: center">
                                            <base-button v-if="true" size="sm" icon type="success" class="mb-2" style="background-color: #28a745; color: white; font-size: 0.8125rem" @click="addRow()">
                                                <span class="btn-inner--icon"><i class="fas fa-plus-circle"></i></span>
                                                <span class="btn-inner--text">Tambah</span>
                                            </base-button>
                                        </div>
                                    </template>
                                    <template slot-scope="scope">
                                        <!-- Butang Kemaskini dengan warna biru -->
                                        <base-button size="sm" icon type="primary" class="mb-2" style="background-color: #3498db; color: white; font-size: 0.8125rem" @click="EditVal(scope.row)">
                                            <span class="btn-inner--icon"><i class="ni ni-ruler-pencil"></i></span>
                                            <span class="btn-inner--text">KEMASKINI</span>
                                        </base-button>

                                        <!-- Butang Padam dengan warna merah -->
                                        <base-button v-if="scope.$index == objGajiCO.length - 1" size="sm" icon type="danger" class="mb-2" style="background-color: #e74c3c; color: white; font-size: 0.8125rem" @click="delVal(scope.row)">
                                            <span class="btn-inner--icon"><i class="fas fa-trash-alt"></i></span>
                                            <span class="btn-inner--text">PADAM</span>
                                        </base-button>
                                    </template>
                                </el-table-column>
                                </el-table>
                        </div>
                    </b-card-text>
                    <br/>
                    <!-- <base-button
                    type="danger"
                    size="md"
                    :disabled="selectedRows.length === 0"
                    @click="deleteSelected"
                    >
                    Hapus Dipilih ({{ selectedRows.length }})
                    </base-button> -->
                    <base-button size="xl" icon type="success" class="mb-2" style="background-color: #28a745; color: white; font-size: 1.12rem" @click="selesai()">
                        <span class="btn-inner--icon"><i class="fas fa-check-circle"></i></span>
                        <span class="btn-inner--text">SELESAI</span>
                    </base-button>
                    <!-- Butang Kemaskini -->
            <!-- <base-button icon type="warning" class="mb-2" style="font-size: 0.8125rem" @click="hantarMD">
                <span class="btn-inner--icon"><i class="ni ni-settings-gear-65"></i></span>
                <span class="btn-inner--text">HANTAR PERMOHONAN</span>
            </base-button> -->
            <!-- Butang Sejarah -->
            <!-- <base-button  icon type="info" class="mb-2" style="font-size: 0.8125rem" @click="openSejarah">
                <span class="btn-inner--icon"><i class="ni ni-collection"></i></span>
                <span class="btn-inner--text">SEJARAH</span>
            </base-button> -->
                </b-card-body>

            </b-card>
        </div>
    </card>

    <!--Form modal-->
    <modal :show.sync="modals.addYear" size="xl" body-classes="p-1">
        <template slot="header">
            <h3 class="mb-0">TAMBAH TAHUN</h3>
        </template>
        <template>
            <MDLAddYear @batal="batal"></MDLAddYear>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
    <!--Form delete-->
    <modal :show.sync="modals.DelYear" size="xl" body-classes="p-1">
        <template slot="header">
            <h3 class="mb-0">HAPUS TAHUN</h3>
        </template>
        <template>
            <MDDelYear :YearRow="YearRow" @batal="batal" @refreshPaging="refreshPaging"></MDDelYear>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
    <!--Form edit-->
    <modal :show.sync="modals.edit" size="xl" body-classes="p-1">
        <template slot="header">
            <h3 class="mb-0">KEMASKINI</h3>
        </template>
        <template>
            <edit :YearRow="YearRow" @batal="batal" @refreshPaging="refreshPaging"></edit>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
    <!--HANTAR PERMOHONAN-->
    <modal :show.sync="modals.hantar" size="xl" body-classes="p-1">
        <template slot="header">
            <h3 class="mb-0">HANTAR PERMOHONAN</h3>
        </template>
        <template>
            <MDHantarPermoh  @batal="batal" @refreshPaging="refreshPaging"></MDHantarPermoh>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
</div>
</template>

<script>
import swal from "sweetalert2";
import moment from "moment";
import {
    Table,
    TableColumn,
    MessageBox,
    Pagination
} from "element-ui";
import MDLAddYear from "@/views/Skg/MDLAddYear.vue";
import MDDelYear from "@/views/Skg/MDDelYear.vue";
import MDHantarPermoh from "@/views/Skg/MDhantarPermoh.vue";
import edit from "@/views/Skg/edit.vue";

import Store from "@/store";
import GetsalaryService from "@/services/salaryService.js";
export default {
    props: ["ICNo"],
    name: "light-table",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        MDLAddYear,
        MDDelYear,
        MDHantarPermoh,
        edit,
        
    },
    data() {
        return {

            active: false,
            objtahunLatest: {},
            modals: {
                addYear: false,
                DelYear: false,
                edit: false,
                hantar: false,
            },
            YearRow: {},
            objMaklPer: {},
            objGajiCO: [],
        };
    },

    methods: {
        formatCurrency(row, column, cellValue) {
    if (!cellValue) return 'RM 0.00'; // Jika tiada nilai
    return `RM ${parseFloat(cellValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  },
        rowClassName({
            row,
            column,
            rowIndex
        }) {
            //console.log("StatusKadarTetap:", row.StatusKadarTetap); // Debug
            if (row.AmaunTelahTerima != row.SalAmtCalc) {
                //console.log("Menetapkan kelas 'highlight-row'"); // Debug
                if(column.property == 'AmaunTelahTerima') {
                    return 'highlight-row';
                }
            }
            return '';
        },

        addRow() {
            this.modals.addYear = true;
            this.modals.DelYear = false;
        },
        batal() {
            this.modals.addYear = false;
            this.modals.DelYear = false;
            this.modals.edit = false;
            this.ButiranTahun();
        },
        delVal(scope) {
            console.log("scope", scope)
            this.modals.addYear = false;
            this.modals.DelYear = true;
            this.YearRow = scope;
        },
        EditVal(scope) {
            console.log("scope", scope)
            this.modals.addYear = false;
            this.modals.DelYear = false;
            this.modals.edit = true;
            this.YearRow = scope;
        },
        hantarMD() {
            this.modals.hantar = true;
        },
        selesai() {
            let Search = {
                coid: this.objMaklPer.coid
            };

            GetsalaryService.updRow(Search)
                .then((resp) => {
                    console.log(this.objMaklPer)
                    swal.fire({
                        title: `KEMASKINI BERJAYA`,
                        text: "",
                        buttonsStyling: true,
                        icon: "success",
                    }).then(() => {
                        this.$router.push({
                            name: "BUTIRAN MAKLUMAT GAJI",
                            params: {
                                ICNo: this.objMaklPer.ICNo,
                                coid: this.objMaklPer.coid,
                            },
                        });
                    });
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        ButiranTahun() {
            let search = {
                currentPage: 1,
                coid: this.objMaklPer.coid,
            };
            GetsalaryService.getButiranTahunInfoParam(search)
                .then((resp) => {
                    // this.pemanggil = resp.data;
                    this.ClientPaging = resp.data;
                })
                .then(() => {
                    //this.queryPageData(1);
                    GetsalaryService.getButiranTahunDataParam(search).then((resp) => {
                        this.objGajiCO = resp.data;
                        console.log("objGajiCO", this.objGajiCO);
                    });
                });
        },
        refreshPaging() {
            this.ButiranTahun();
        },
    },
    computed: {},
    created() {
        let condPenjawatAwam = {
            ICNo: this.ICNo,
        };

        GetsalaryService.getMaklPenjawatAwam(condPenjawatAwam)
            .then((resp) => {
                this.objMaklPer = resp.data[0];
                console.log("maklumat peribadi", this.objMaklPer);
                this.objMaklPer.DtLantikanPertama = moment(this.objMaklPer.DtLantikanPertama, "YYYY-MM-DD").format("DD-MM-YYYY");

                this.$store.commit("addMaklumatPeribadi", this.objMaklPer);
            })
            .then(() => {
                this.ButiranTahun();
            })
            .catch((err) => {
                console.log(err);
            });

    },
};
</script>

<style>
.highlight-row {
    color: rgb(200, 0, 0) !important;
    /* Warna merah gelap */
    font-weight: bold !important;
    /* Menjadikan semua teks dalam baris bold */
}

.bg-light {
    background-color: #f9fbfd;
    /* Warna latar belakang yang lebih lembut */
    border: 1px solid #e3e6f0;
    /* Warna sempadan yang ringan */
    border-radius: 1px;
    /* Penjuru bulat */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    /* Bayangan lembut */
    padding: 20px;
    /* Jarak dalaman */
    margin-bottom: 20px;
    /* Ruang di bawah setiap bingkai */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    /* Animasi untuk interaksi */
}

/* Animasi ketika hover */
.bg-light:hover {
    transform: translateY(-5px);
    /* Bergerak sedikit ke atas */
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
    /* Bayangan lebih ketara */
}

.bg-light h4 {
    font-size: 1.5rem;
    /* Saiz fon yang lebih besar */
    font-weight: 600;
    /* Ketebalan teks */
    color: #5e72e4;
    /* Warna biru terang */
    margin-bottom: 15px;
}

.bg-light p {
    font-size: 1rem;
    color: #525f7f;
    /* Warna teks kelabu lembut */
    line-height: 1.6;
    /* Jarak antara baris */
}

.bg-white {
    background-color: #ffffff;
    /* Latar belakang putih bersih */
    border: 1px solid #e4e7ea;
    /* Sempadan ringan */
    border-radius: 10px;
    /* Penjuru bulat */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /* Bayangan lembut */
    padding: 20px;
    /* Jarak dalaman */
    margin-bottom: 20px;
    /* Ruang di bawah setiap elemen */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    /* Animasi untuk interaksi */
}

/* Kesan hover */
.bg-white:hover {
    transform: translateY(-5px);
    /* Sedikit gerakan ke atas */
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
    /* Bayangan lebih ketara */
}

.bg-white {
    background-color: #ffffff;
    /* Latar belakang putih bersih */
    border: 1px solid #e4e7ea;
    /* Sempadan ringan */
    border-radius: 10px;
    /* Penjuru bulat */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /* Bayangan lembut */
    padding: 20px;
    /* Jarak dalaman */
    margin-bottom: 20px;
    /* Ruang di bawah setiap elemen */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    /* Animasi untuk interaksi */
        color: #000 !important;
    font-weight: bold !important;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.15);
}

/* Kesan hover */
.bg-white:hover {
    transform: translateY(-5px);
    /* Sedikit gerakan ke atas */
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
    /* Bayangan lebih ketara */
}

.bg-white h4 {
    font-size: 1.5rem;
    /* Saiz teks tajuk */
    font-weight: bold;
    /* Teks tebal */
    color: #32325d;
    /* Warna teks gelap */
    margin-bottom: 15px;
    /* Jarak bawah tajuk */
}

.bg-white p {
    font-size: 1rem;
    /* Saiz teks kandungan */
    color: #5e72e4;
    /* Warna biru lembut */
    line-height: 1.6;
    /* Jarak antara baris teks */
    margin-bottom: 10px;
    /* Jarak bawah teks */
}

.el-table .el-table__cell {
  color: #1a1a1a; /* Warna hitam gelap */
  font-weight: 500;
  font-size: 1232324px;
}

.info-table .value {
    font-weight: 550;
    color: #000; /* warna hitam pekat */
}
</style>
